<template>
	<div class="popup show-popup" v-show="show">
		<div class="popup-content" v-if="showHasAccess">
			<h4>Draga učenka, dragi učenec!</h4>
            <p>Tvoj dostop na iRokusPlus.si je med 8. uro zjutraj in 14. uro popoldne mogoč v skupnem času ene ure za posamezno interaktivno gradivo.</p>
            <p>Neomejen dostop smo ti omogočili od 14. ure popoldne do 8. ure zjutraj ter ves dan ob dnevih brez pouka.</p>
            <p><input ref="cookie-check" type="checkbox" name="hide-access-restriction" id="hide-access-restriction">
                <label for="hide-access-restriction">Tega sporočila ne kaži več.</label></p>
			<p class="bottom">
                <a href="#" class="button mr-3" v-on:click.prevent="close(false)">Nazaj v iZbirko</a>
                <a href="#" class="button green" v-on:click.prevent="close(true)">V redu</a>
            </p>
		</div>
        <div class="popup-content" v-if="showHasNoAccess">
            <h4>Draga učenka, dragi učenec!</h4>
            <p>Čas je potekel. Tvoj dostop na iRokusPlus.si je med 8. uro zjutraj in 14. uro popoldne mogoč v skupnem času ene ure za posamezno interaktivno gradivo.</p>
            <p>Neomejen dostop smo ti omogočili od 14. ure popoldne do 8. ure zjutraj ter ves dan ob dnevih brez pouka.</p>
            <p class="bottom">
                <a href="#" class="button green" v-on:click.prevent="close(false)">Nazaj v iZbirko</a>
            </p>
		</div>
	</div>
</template>

<script>
	import popup from '../popup.js'

	export default {
        props: ['data'],
        mixins: [popup],
        data() {
            return {
                show: false
            }
        },
        mounted() {
            if (this.showHasAccess && this.$cookies.isKey(this.$refs['cookie-check'].name)) {
                this.close(true);
            } else {
                this.show = true;
            }
        },
		methods: {
			close(state) {
                if (this.showHasAccess && this.$refs['cookie-check'].checked) {
                    this.$cookies.set(this.$refs['cookie-check'].name, true, 60 * 60 * 24 * 30);
                }
				if (state) {
                    window.open(this.data.url);
                } 
                this.$root.$emit('close-popup', this);
			}
        },
        computed: {
            showHasAccess() {
                return this.data.withinTimeRestriction && this.data.hasAccess;
            },
            showHasNoAccess() {
                return !this.data.hasAccess;
            }
        }
	}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/PopupHasAccess.vue